"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotImplementedPage = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var layout_1 = require("../_shared/components/layout");
var react_router_dom_1 = require("react-router-dom");
var reducers_1 = require("../_shared/reducers/");
require("./NotImplementedPage.scss");
var NotImplementedPage = /** @class */ (function (_super) {
    __extends(NotImplementedPage, _super);
    function NotImplementedPage(props) {
        return _super.call(this, props) || this;
    }
    NotImplementedPage.prototype.logout = function () {
        this.props.history.replace('login');
        this.props.logout();
    };
    NotImplementedPage.prototype.render = function () {
        var _this = this;
        return (React.createElement(layout_1.Page, { id: "not-implemented-page" },
            React.createElement(layout_1.Column, null,
                React.createElement(layout_1.Column, { alignItems: "center", justifyContent: "center" },
                    "This page is not yet develop ",
                    React.createElement("br", null),
                    " Have a nice green day!",
                    React.createElement(react_router_dom_1.Link, { to: "/dashboard", className: "go-back" }, "Go Back"),
                    React.createElement("a", { onClick: function () { return _this.logout(); } }, " Logout ")))));
    };
    return NotImplementedPage;
}(React.Component));
exports.NotImplementedPage = NotImplementedPage;
var mapDispatchToProps = function (dispatch) { return ({
    logout: function () { return reducers_1.LoginActions.logout()(dispatch); },
}); };
var Container = (0, react_redux_1.connect)(null, mapDispatchToProps)(NotImplementedPage);
exports.default = Container;
